import { render, staticRenderFns } from "./TaskAdminYuSouList.vue?vue&type=template&id=643d6813&"
import script from "./TaskAdminYuSouList.vue?vue&type=script&lang=js&"
export * from "./TaskAdminYuSouList.vue?vue&type=script&lang=js&"
import style0 from "./TaskAdminYuSouList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports